<div class="modalForm">
  <div class="flex flex-column gap-2 mb-3">
    <span>{{ "device_management.devices.update_dialog.device_type" | translate }}</span>
    <span> {{ deviceType() }} </span>
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <span>
      {{ "device_management.devices.update_dialog.device_count" | translate }}
    </span>
    <span> {{ devices().length }} </span>
  </div>

  <div class="flex flex-column gap-2 mb-3" style="grid-column: 1/3">
    <span>{{ "device_management.devices.update_dialog.device_list" | translate }} </span>

    <p-table [value]="devices()" [columns]="devicesColumns" scrollHeight="200px" scrollable="true">
      <ng-template #header let-columns>
        <tr>
          @for (col of columns; track col) {
            <th>
              {{ col.header | translate }}
            </th>
          }
        </tr>
      </ng-template>
      <ng-template #body let-rowData let-columns="columns">
        <tr>
          @for (col of columns; track col) {
            <td>
              {{ rowData[col.field] }}
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <span> {{ "device_management.devices.update_dialog.software_versions" | translate }}</span>
    <p-select
      class="w-full"
      appendTo="body"
      [options]="softwareVersions()"
      optionLabel="version"
      optionValue="version"
      [(ngModel)]="selectedVersion"
    />
  </div>
  <div class="flex justify-content-end gap-2 dialogBtnGroup" style="grid-column: 1/3">
    <app-button id="cancelBuildingButton" buttonText="common.cancel" (click)="closeDialog()"></app-button>
    <app-button buttonText="common.save" [disabled]="!fieldsValid()" (click)="save()"></app-button>
  </div>
</div>
